import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-surfschule',
  templateUrl: './surfschule.component.html',
  styleUrls: ['./surfschule.component.css']
})
export class SurfschuleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/AnnaNorbisrath/WebstormProjects/me.rainer.surfschule-wiesensee/src/app/surfschule/surfschule.component.ts